import { get, post, put } from 'app/shared/utils/fetchr';

// Models
import {
  EditEntityPayload,
  EntityAlertsPayload,
} from 'app/modules/entitiesOld/models';
import { FullEntityResponse } from 'app/modules/entities/responses';

// Utils
import routes from 'app/shared/utils/routes';

export const getEntity = (id) => get(`/entities/${encodeURIComponent(id)}`);

export const editEntity = (payload: EditEntityPayload) => {
  const { id, ...details } = payload;
  const path = routes.patronus.entitiesEditId.replace(':id', `${id}`);
  return put(path, details);
};

export const getEntityAlerts = (payload: EntityAlertsPayload) => {
  const { entityExternalId, ...details } = payload;
  const path = routes.patronus.entitiesIdPaginatedAlerts.replace(
    ':entity-external-id',
    `${encodeURIComponent(entityExternalId)}`,
  );
  return post(path, details);
};

export const getEntityByExternalId = (
  entityExternalId: string,
): Promise<FullEntityResponse> =>
  get(`/unit21/entities/${encodeURIComponent(entityExternalId)}`);
